<template>
    <div v-if="getMenuIsActive" class="sidebar">
    <!--<div :class="{'vissible' : getMenuIsActive}" class="sidebar">-->
        <div class="mobile-sidebar-close">
            <button v-bind:class="{ 'is-active': getMenuIsActive }" class="hamburger hamburger--collapse" type="button" @click="handleClick()">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </button>
        </div>
        <div class="sidebar-body">
            <div class="avat">
                <div class="hold">
                    <img :src="getDataOnLogin.profileimage" alt="">
                    <!--                name-->
                    <div data-v-c1c52d9e="" class="name">
                        <p class="greetings">{{getDataOnLogin.customername | firstCaseCapitalSpace}}</p>
                        <!--                        <p class="lastLogin">lucaslumbex@hotmail.com</p>-->
                        <p class="lastLogin">{{getDataOnLogin.lastlogin}}</p>
                    </div>
                </div>
            </div>
            <div class="actions">
                <a v-if="getSideBarPage === 'dashboard'" @click="goToDashboard()" class="current active">
                    <i class="nav-icon i-Dashboard"></i>
                    Dashboard
                </a>
                <a v-else @click="goToDashboard()" class="current">
                    <i class="nav-icon i-Dashboard"></i>
                    Dashboard
                </a>

                <p @click="" class="label">ACTIONS</p>
                <ul>
                    <li>
                        <a v-if="getSideBarPage === 'buy-airtime'" @click="goToBuyAirtime()" class="active">
                            <i class="nav-icon i-Plastic-Cup-Phone"></i>
                            <span>Buy Airtime</span>
                        </a>
                        <a v-else @click="goToBuyAirtime()">
                            <i class="nav-icon i-Plastic-Cup-Phone"></i>
                            <span>Buy Airtime</span>
                        </a>
                    </li>

                    <li>
                        <a v-if="getSideBarPage === 'send-money'" @click="goToSendMoney()" class="active">
                            <i class="nav-icon i-Coins"></i>
                            <span>Send Money</span>
                        </a>
                        <a v-else @click="goToSendMoney()" class="">
                            <i class="nav-icon i-Coins"></i>
                            <span>Send Money</span>
                        </a>
                    </li>

                    <li>
                        <a v-if="getSideBarPage === 'pay-bills'" @click="goToPayBills()" class="active">
                            <i class="nav-icon i-Billing"></i>
                            <span>Pay Bills</span>
                        </a>
                        <a v-else @click="goToPayBills()">
                            <i class="nav-icon i-Billing"></i>
                            <span>Pay Bills</span>
                        </a>
                    </li>

                    <li>
                        <a v-if="getSideBarPage === 'account-statement'" @click="goToAccountStatement()" class="active">
                            <i class="nav-icon i-Statistic"></i>
                            <span>Account Statement</span>
                        </a>
                        <a v-else @click="goToAccountStatement()">
                            <i class="nav-icon i-Statistic"></i>
                            <span>Account Statement</span>
                        </a>
                    </li>

                    <li>
                        <a v-if="getSideBarPage === 'independent-banker'" @click="goToIndependentBanker()" class="active">
                            <i class="nav-icon i-Bank"></i>
                            <span>Independent Banker</span>
                        </a>
                        <a v-else @click="goToIndependentBanker()">
                            <i class="nav-icon i-Bank"></i>
                            <span>Independent Banker</span>
                        </a>
                    </li>

                    <li>
                        <a v-if="getSideBarPage === 'money-request'" @click="goToMoneyRequest()" class="active">
                            <i class="nav-icon i-Receipt"></i>
                            <span>Money Request</span>
                        </a>
                        <a v-else @click="goToMoneyRequest()">
                            <i class="nav-icon i-Receipt"></i>
                            <span>Money Request</span>
                        </a>
                    </li>

                    <li>
                        <a v-if="getSideBarPage === 'all-accounts'" @click="goToAllAccounts()" class="active">
                            <i class="nav-icon i-Credit-Card"></i>
                            <span>All Accounts</span>
                        </a>
                        <a v-else @click="goToAllAccounts()">
                            <i class="nav-icon i-Credit-Card"></i>
                            <span>All Accounts</span>
                        </a>
                    </li>
                    <li>
                        <a  @click="goToSignOut()">
                            <i class="nav-icon i-Lock"></i>
                            <span>Sign Out</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>



        <!--UI Modal For Displaying Transfer Success Message-->
        <ui-modal
                ref="transferSuccessModal" transition="scale-up"
                :removeHeader= "true" size="small" @hide="endTransfer"
                align-top :align-top-margin="200"
        >
            <div class="notification-modal sm">
                <div class="head">
                    <div class="logo-hold">
                        <div>
                            <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                        </div>
                    </div>
                </div>

                <div class="bottom">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-2">
                                <div class="left">
                                    <div class="status-icon">
                                        <svg class="success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496.2 496.2">
                                            <path d="M496.2 248.1c0-137-111.1-248.1-248.1-248.1C111.1 0 0 111.1 0 248.1c0 137 111.1 248.1 248.1 248.1C385.1 496.2 496.2 385.1 496.2 248.1z"></path>
                                            <path d="M384.7 165c-5.8-15.1-17.7-12.7-30.6-10.1 -7.7 1.6-42 11.6-96.1 68.8 -22.5 23.7-37.3 42.6-47.1 57 -6-7.3-12.8-15.2-20-22.3 -22.1-22.1-46.7-37.2-47.7-37.9 -10.3-6.3-23.8-3.1-30.2 7.3 -6.3 10.3-3.1 23.8 7.2 30.2 0.2 0.1 21.4 13.2 39.6 31.5 18.6 18.6 35.5 43.8 35.7 44.1 4.1 6.2 11 9.8 18.3 9.8 1.2 0 2.5-0.1 3.8-0.3 8.6-1.5 15.4-7.9 17.5-16.3 0.1-0.2 8.8-24.3 54.7-72.7 37-39.1 61.7-51.5 70.3-54.9 0.1 0 0.1 0 0.3 0 0 0 0.3-0.1 0.8-0.4 1.5-0.6 2.3-0.8 2.3-0.8 -0.4 0.1-0.6 0.1-0.6 0.1l0-0.1c4-1.7 11.4-4.9 11.5-5C385.4 188.2 389 176.2 384.7 165z" fill="#FFF"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div class="col-10 pl-2">
                                <div class="right">
                                    <p>
                                        Congratulations!! <br>
                                        {{successMessage}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-button">
                        <button @click="closeModal('transferSuccessModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                    </div>
                </div>
            </div>
        </ui-modal>

        <!--UI Modal For Displaying Transfer Failed Message-->
        <ui-modal
                ref="transferFailModal" transition="scale-up"
                :removeHeader= "true" size="small" @hide="endTransfer"
                align-top :align-top-margin="200"
        >
            <div class="notification-modal sm">
                <div class="head">
                    <div class="logo-hold">
                        <div>
                            <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                        </div>
                    </div>
                </div>

                <div class="bottom">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-2">
                                <div class="left">
                                    <div class="status-icon">
                                        <svg class="error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 455.1 455.1">
                                            <circle cx="227.6" cy="227.6" r="227.6" fill="#E24C4B"></circle>
                                            <path d="M455.1 227.6c0 125.2-102.4 227.6-227.6 227.6 -72.5 0-136.5-32.7-177.8-85.3 38.4 31.3 88.2 49.8 142.2 49.8 125.2 0 227.6-102.4 227.6-227.6 0-54-18.5-103.8-49.8-142.2C422.4 91 455.1 155 455.1 227.6z" fill="#D1403F"></path>
                                            <path d="M331.4 331.4c-8.5 8.5-22.8 8.5-31.3 0l-72.5-72.5 -72.5 72.5c-8.5 8.5-22.8 8.5-31.3 0 -8.5-8.5-8.5-22.8 0-31.3l72.5-72.5 -72.5-72.5c-8.5-8.5-8.5-22.8 0-31.3 8.5-8.5 22.8-8.5 31.3 0l72.5 72.5 72.5-72.5c8.5-8.5 22.8-8.5 31.3 0 8.5 8.5 8.5 22.8 0 31.3l-72.5 72.5 72.5 72.5C339.9 308.6 339.9 322.8 331.4 331.4z" fill="#FFF"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div class="col-10 pl-2">
                                <div class="right">
                                    <p>
                                        Failed!! <br>
                                        {{errorMessage}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-button">
                        <button @click="closeModal('transferFailModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                    </div>
                </div>
            </div>
        </ui-modal>
    </div>
</template>

<script>
    import {TweenMax, Power4} from 'gsap'
    import {mapGetters, mapActions} from 'vuex'


    export default {
        name: "sidebar",
        components: { },
        props: { },
        data () {
            return {
                successMessage: '',
                errorMessage: '',
            }
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getInsideCurrentPage',
                'getDataOnLogin',
                'getUsername',
                'getMobileSideNavActive',
                'getInsideCurrentPage',
                'getMenuIsActive',
            ]),

            open () {
                return this.$store.state.sidebarOpen
            }
        },
        watch: {
            open: function (open) {
                const dX = open ? 0 : this.$el.offsetWidth
                TweenMax.to(this.$el, 0.6, {
                    x: dX,
                    ease: Power4.easeOut
                })
            }
        },
        created () {},
        methods: {
            ...mapActions([
                'updateAppLoading',
                'updateDataOnLogin',
                'updateUsername',
                'updateSideBarPage',
                'updateCurrentComponent',
                'updateInsideCurrentPage',
                'updateIBankerList',
                'updateMoneyRequestSentList',
                'updateMoneyRequestReceivedList',
                'updateCurrentAirtimePhoneNo',
                'updateMobileSideNavActive',
                'updateMenuIsActive',
            ]),

            handleClick () {
                this.$store.dispatch('toggleSidebar')
                this.updateMenuIsActive (!this.getMenuIsActive)
            },
            closeMobileSidebar(){
                console.log('Close Side Bar')

                // this.active= false;
                this.updateMobileSideNavActive(false);

                console.log('Changed Active ==>', this.active)
            },
            goToDashboard(){
                //close the mobile side nav
                this.handleClick()
                // setTimeout(()=>{
                    //
                    //update "sideBarPage" in the store
                    this.updateSideBarPage('dashboard');

                    //Update the current sub component in the store
                    this.updateInsideCurrentPage('dashboard')
                // }, 500);
            },
            goToSendMoney(){
                //close the mobile side nav
                this.handleClick()
                // setTimeout(()=>{
                    console.log('Current side bar value ==>>', this.getMobileSideNavActive)
                    //update "sideBarPage" in the store
                    this.updateSideBarPage('send-money');

                    //Update the current sub component in the store
                    this.updateInsideCurrentPage('sendMoney')

                // }, 500);
            },
            goToPayBills(){
                //close the mobile side nav
                this.handleClick()
                // setTimeout(()=>{
                    //
                    //update "sideBarPage" in the store
                    this.updateSideBarPage('pay-bills');

                    //Update the current sub component in the store
                    this.updateInsideCurrentPage('payBills')
                // }, 500);
            },
            goToBuyAirtime(){
                //close the mobile side nav
                this.handleClick()
                // setTimeout(()=>{
                    //
                    // update current airtime phone number
                    this.updateCurrentAirtimePhoneNo([this.getDataOnLogin.countrycode, '0'+this.getDataOnLogin.mobilenumber])

                    //Update the current sub component in the store
                    this.updateInsideCurrentPage('airtime')
                // }, 500);
            },
            goToAllAccounts(){
                //close the mobile side nav
                this.handleClick()
                // setTimeout(()=>{
                    //
                    //update "sideBarPage" in the store
                    this.updateSideBarPage('all-accounts');

                    //Update the current sub component in the store
                    this.updateInsideCurrentPage('allAccount')
                // }, 500);
            },
            goToIndependentBanker(){
                //close the mobile side nav
                this.handleClick()
                // setTimeout(()=>{
                    //
                    //start app loading
                    this.updateAppLoading(true);

                    let bodyToSend = {
                        customerid: this.getDataOnLogin.customerid,
                    }

                    axios
                        .post('/mybankercustomers', bodyToSend,
                            {
                                headers : {
                                    'Authorization': this.getDataOnLogin.authorization,
                                    'Content-Type': 'application/json',
                                    'Access-Control-Allow-Origin': '*'
                                }})
                        .then(response => {
                            //stop app running
                            this.updateAppLoading(false);

                            let responseData =  response.data;

                            console.log('responseData ==>>', responseData)

                            if (responseData.responsecode === '00') {
                                this.updateIBankerList (responseData.result);

                                //update "sideBarPage" in the store
                                this.updateSideBarPage('independent-banker');

                                //Update the current sub component in the store
                                this.updateInsideCurrentPage('independentBanker')

                            } else {

                                // display error notification
                                this.showAlert(true, 'error', responseData.responsemessage)
                            }
                        })
                        .catch(error => {
                            //stop app running
                            this.updateAppLoading(false);

                            // log Error
                            console.log(error);
                        })
                // }, 500);
            },
            goToMoneyRequest(){
                //close the mobile side nav
                this.handleClick()
                // setTimeout(()=>{
                    //
                    //start app loading
                    this.updateAppLoading(true);


                    let bodyToSend = {
                        username: this.getUsername
                    }

                    axios
                        .post('/requestmoneysentlist', bodyToSend,
                            {
                                headers : {
                                    'Authorization': this.getDataOnLogin.authorization,
                                    'Content-Type': 'application/json',
                                    'Access-Control-Allow-Origin': '*'
                                }})
                        .then(response => {
                            //stop app running
                            this.updateAppLoading(false);

                            let responseData =  response.data;

                            console.log('responseData ===>>', responseData)


                            if (responseData.responsecode === '00'|| responseData.responsecode === '01') {
                                if (responseData.responsecode === '01'){
                                    this.updateMoneyRequestSentList([])
                                } else {
                                    this.updateMoneyRequestSentList(responseData.result)
                                }

                                axios
                                    .post('/requestmoneyreceivedlist', bodyToSend,
                                        {
                                            headers : {
                                                'Authorization': this.getDataOnLogin.authorization,
                                                'Content-Type': 'application/json',
                                                'Access-Control-Allow-Origin': '*'
                                            }})
                                    .then(response2 => {
                                        //stop app running
                                        this.updateAppLoading(false);

                                        let responseData2 =  response2.data;

                                        console.log('responseData2 ==>>', responseData2)

                                        if (responseData2.responsecode === '00'|| responseData.responsecode === '01') {
                                            if (responseData.responsecode === '01'){
                                                this.updateMoneyRequestReceivedList([])

                                            } else {
                                                this.updateMoneyRequestReceivedList(responseData2.result)
                                            }
                                            //update "sideBarPage" in the store
                                            this.updateSideBarPage('money-request');

                                            //Update the current sub component in the store
                                            this.updateInsideCurrentPage('moneyRequest')
                                        } else {
                                            if (responseData.responsecode === '00'){
                                                this.updateMoneyRequestReceivedList([])

                                                //update "sideBarPage" in the store
                                                this.updateSideBarPage('money-request');

                                                //Update the current sub component in the store
                                                this.updateInsideCurrentPage('moneyRequest')
                                            }
                                            else {
                                                // equate the response message and show transferFailModal
                                                this.errorMessage = responseData2.responsemessage;
                                                this.openTransferFailModal();
                                            }
                                        }
                                    })
                                    .catch(error => {
                                        //stop app running
                                        this.updateAppLoading(false);

                                        // log Error
                                        console.log(error);

                                        // equate the response message and show transferFailModal
                                        this.errorMessage = error;
                                        this.openTransferFailModal();
                                    })
                            } else {

                                // equate the response message and show transferFailModal
                                this.errorMessage = responseData.responsemessage;
                                this.openTransferFailModal();
                            }
                        })
                        .catch(error => {
                            //stop app running
                            this.updateAppLoading(false);

                            // log Error
                            console.log('--------Error----', error ,'----Error--------');

                            // equate the response message and show transferFailModal
                            this.errorMessage = error;
                            this.openTransferFailModal();
                        })
                // }, 500);
            },
            goToAccountStatement(){
                //close the mobile side nav
                this.handleClick()
                // setTimeout(()=>{
                    //
                    //update "sideBarPage" in the store
                    this.updateSideBarPage('account-statement');

                    //Update the current sub component in the store
                    this.updateInsideCurrentPage('accountStatement')
                // }, 500);
            },
            goToSignOut(){
                //close the mobile side nav
                this.handleClick()
                // setTimeout(()=>{
                    //
                    //start app loading
                    this.updateAppLoading(true);

                    axios
                        .post('/logout', {
                            username: this.getUsername
                        })
                        .then(response => {
                            //stop app running
                            this.updateAppLoading(false);

                            let responseData = response.data;

                            if (responseData.responsecode === '00'){
                                this.actualLogout()
                            }
                        })
                        .catch(error => {
                            console.log('Alt Log out');

                            this.actualLogout()
                        })
                // }, 500);
            },

            openModal(ref) {
                this.$refs[ref].open();
            },
            closeModal(ref) {
                this.$refs[ref].close();
            },
            openTransferFailModal(){
                //Open The TransferSuccessModal
                this.openModal('transferFailModal');
            },
            closeTransferFailModal(){
                //Close the TransferSuccessModal
                this.closeModal('transferFailModal')
            },
            endTransfer(){
                console.log('Success Modal Hide')
                //Update the current sub component in the store
                this.updateInsideCurrentPage('dashboard')
            },

            actualLogout(){
                // reset the data on login to an empty string
                this.updateDataOnLogin('');
                this.updateUsername('');

                //redirect to the login page
                this.updateCurrentComponent('login')
            },
        },
        mounted(){
            TweenMax.set(this.$el, {
                x: this.$el.offsetWidth
            })
        },

    }
</script>

<style scoped>
.vissible{
    /*visibility: visible;*/
}
.sidebar{
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    /*max-width: 90vw;*/
    max-width: 100vw;
    background-color: #fff;
    z-index: 99;
    /*visibility: hidden;*/
}
.mobile-sidebar-close{
    cursor: pointer;
    position: absolute;
    top: 15px;
    right: 20px;
    z-index: 999;
}
.mobile-sidebar-close svg{
    height: 25px;
    width: 25px;
}
.hamburger {
    padding: 8px;
    float: right;
    cursor: pointer;
}
</style>